"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyType = void 0;
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["None"] = "None";
    CurrencyType["AustralianDolar"] = "AUD";
    CurrencyType["CanadianDollar"] = "CAD";
    CurrencyType["Euro"] = "EUR";
    CurrencyType["BritishPound"] = "GBP";
    CurrencyType["USDollar"] = "USD";
})(CurrencyType = exports.CurrencyType || (exports.CurrencyType = {}));
//# sourceMappingURL=currency-type.js.map